import * as yup from 'yup'

const durationValidationSchema = yup.object().shape({
    DurationDateDébut: yup
        .string()
        .required('La date de début est requise')
        .matches(/^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/([0-9]{4})$/, 'Format attendu JJ/MM/AAAA'),
    DurationDateFin: yup
        .string()
        .required('La date de fin est requise')
        .matches(/^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/([0-9]{4})$/, 'Format attendu JJ/MM/AAAA'),
});

export default durationValidationSchema;